//
// WarningLevel.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var WarningLevel = {
    INFO_LEVEL:0,
    WARNING_LEVEL:1,
    ERROR_LEVEL:2,
    FATAL_LEVEL:3
};
export default WarningLevel;
